export const environment = {
  production: false,
  firebase: {
  apiKey: "AIzaSyDSmddZ0ghUyNvgHc6zMb4RwFlHjYfNwdw",
  authDomain: "physioproject1.firebaseapp.com",
  projectId: "physioproject1",
  storageBucket: "physioproject1.firebasestorage.app",
  messagingSenderId: "142317704134",
  appId: "1:142317704134:web:f1bdd746beb8d78ef0d8c7"  }
};
